import type { BrandConfig } from '@comparit/infrastructure';
import { Deckungsumfang } from '../../../interfaces';
import { MlpHeaderComponent } from './mlp-header.component';
import { MlpCallbackLinkComponent } from './mlp-callback-link.component';
import { MlpLoginBannerComponent } from './mlp-login-banner.component';
import { MlpLoginDialogComponent } from './mlp-login-dialog/mlp-login-dialog.component';
import { MlpFooterComponent } from './mlp-footer.component';
import { MlpCustomerServiceBoxComponent } from './mlp-customer-service-box/mlp-customer-service-box.component';
import { MlpEvbAndererMessageComponent } from './mlp-evb-anderer-message.component';
import { MlpRabattUebertragungMessageComponent } from './mlp-rabatt-uebertragung-message.component';
import { MlpImportHintDialogComponent } from './mlp-import-hint-dialog/mlp-import-hint-dialog.component';
import { mlpEnvironment } from './mlp-environment';
import { mlpPortalDashboardUrl } from './mlp-portal.helper';

export const mlpBrandConfig: BrandConfig = {
  id: 'mlp',
  displayName: 'MLP',
  features: {
    showLogin: true,
    showFooter: true,
    showPoweredByCpit: false,
    showElektroVereinbarungen: true,
    emptyFieldsByDefault: true,
    useSelbstbehaltRecommendation: true,
    pinRecommendation: true,
    showAllTarifsUngrouped: true,
    showContactAlerts: true,
    showDuNote: true,
    showMaklerKfzSuffix: false,
    setOrderHintUsesBerater: true,
    useSchutzRecommendations: true,
    askNameOnSave: true,
    showVermittlerActivationHint: false,
    showNeuwertSchaetzungDisclaimer: true,
    vergleichButtonLabel: 'Tarife vergleichen',
  },
  headerComponent: MlpHeaderComponent,
  headerSecondaryComponent: MlpCallbackLinkComponent,
  loginBannerComponent: MlpLoginBannerComponent,
  footerComponent: MlpFooterComponent,
  erstinformationPdfUrl: 'assets/brands/mlp/MLP-Kundeninformation.pdf',
  customerServiceBoxComponent: MlpCustomerServiceBoxComponent,
  evbAndererMessageComponent: MlpEvbAndererMessageComponent,
  rabattUebertragungMessageComponent: MlpRabattUebertragungMessageComponent,
  loginDialogComponent: MlpLoginDialogComponent,
  importHintDialogComponent: MlpImportHintDialogComponent,
  fallbackSession: 'MLP-001',
  apiUrl: mlpEnvironment.apiUrl,
  portalUrl: mlpPortalDashboardUrl,
  infoTextOverrides: {
    erstinformationCheckbox:
      'Bestätige hier, dass du die Erstinformationen des Versicherungsmaklers MLP Finanzberatung SE gelesen und heruntergeladen hast. Das ist gesetzlich vorgeschrieben (§ 15 VersVermV). Klicke auf „Informationen herunterladen", um das Dokument herunterzuladen.',
    // KFZ-2520: the backend limits the comparison to the eVB insurer for MLP only, so the promise lives here.
    evbVersicherer:
      'Wähle den Versicherer aus, von dem die eVB-Nummer stammt, mit der das Fahrzeug zugelassen wurde oder wird. Bitte beachte: Eine Antragstellung ist nur bei dem Versicherer möglich, von dem die eVB stammt.',
    // KFZ-2539: append Vollkasko recommendation for MLP.
    [Deckungsumfang.MitVollkasko]:
      'Wähle „Vollkasko", wenn du alle Schäden am eigenen Fahrzeug absichern möchtest, einschließlich selbstverschuldeter Unfälle sowie Risiken wie Diebstahl, Glasbruch, Feuer, Sturm oder Wildunfälle.\n\nBei Neufahrzeugen oder jungen Gebrauchtfahrzeugen empfehlen wir den Abschluss einer Vollkaskoversicherung.',
    // KFZ-2715: MLP wants "aktuelle" highlighted in bold and the brand orange.
    schadenfreiheitsklasseHaftpflicht:
      'Gib hier deine <strong class="text-cp-secondary-100">aktuelle</strong> SF-Klasse für die Haftpflichtversicherung an. Die SF-Klasse gibt an, wie viele Jahre du unfallfrei gefahren bist – je höher, desto günstiger dein Beitrag.',
    schadenfreiheitsklasseKasko:
      'Gib hier deine <strong class="text-cp-secondary-100">aktuelle</strong> SF-Klasse für die Kaskoversicherung an. Diese kann von der Haftpflicht-SF-Klasse abweichen.',
    sfKlassenJahreswechsel:
      'Bitte gib die für das <strong class="text-cp-secondary-100">aktuelle</strong> Jahr gültige SF-Klasse ein. Wir berücksichtigen bei der Berechnung automatisch die zum Versicherungsbeginn gültige SF-Klasse.',
  },
};
